import Icon from '@/Icon';
import { clc } from '@/legacy/components/base/utils';
import Img from '@/legacy/components/img/FillImage';
import styles from '@/legacy/components/img/Profilev2.module.scss';

const sizeBySize = {
	0: 0,
	24: 14,
	32: 18,
	40: 24,
	48: 28,
	64: 38,
	80: 48,
	120: 72,
	160: 96,
};
type Props = {
	src?: string | null;
	type: 'COMMON' | 'BUSINESS';
	size: keyof typeof sizeBySize;
	className?: string;
	iconClass?: string;
};
// 이미지 또는 비즈니스 empty 이미지 또는 일반 유저 empty
// 그리고 사이즈 별 empty 이미지 사이즈
const ProfileImageV2 = ({ src, type, size, className, iconClass }: Props) => {
	return (
		<div className={clc(styles['ss' + size], className)}>
			{src && <Img className={clc(styles['s' + size], iconClass)} src={src} />}
			{src == null && type === 'BUSINESS' && (
				<Icon className={clc(styles['s' + size], iconClass)} path="Sticker_Business_Crown_32" />
			)}
			{src == null && type === 'COMMON' && (
				<Icon className={clc(styles['s' + size], iconClass)} color1={'#E0E0E3'} path="Human" />
			)}
		</div>
	);
};

export default ProfileImageV2;
